<template>
  <div>
    <v-toolbar prominent class="pb-4">
      <v-col cols="12" sm="12" md="6">
        <v-text-field
          label="Search for a user"
          outlined
          rounded
          clearable
          dense 
          prepend-inner-icon="mdi-magnify"
        ></v-text-field>
        <v-toolbar-title>
          <span class="pb-1">All Users</span>
        </v-toolbar-title>
      </v-col>

      <v-spacer></v-spacer>
    </v-toolbar>
    <v-container grid-list-md>
      <v-row class="my-2">
        <v-flex md4 v-for="(user,i) in listOfUsers" :key="i" class="pa-2">
          <user-card :user="user"></user-card>
        </v-flex>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import userCard from "@/components/userCard";
import { mapActions, mapState } from 'vuex';
export default {
  components: {
    "user-card": userCard
  },
  data() {
    return {
      //
    };
  },
  created(){
    this.getAllUsers()
  },
  computed: {
    ...mapState("auth", ["listOfUsers"])
  },
  methods: {
    ...mapActions("auth", ["getAllUsers"])
  }
};
</script>